import * as React from "react";
import ReactModal from "react-modal";
import { Component } from "react";

import { getClasses } from "utils";

interface PropsType {
  children: JSX.Element;
  className?: string;
  dismissable?: boolean;
}

interface StateType {
  isOpen: boolean;
}

export default class Modal extends Component<PropsType, StateType> {
  static defaultProps = {
    className: "dialog",
    dismissable: true,
  };

  state = {
    isOpen: false,
  };

  closeModal = (): void => {
    this.setState({ isOpen: false });
  };

  openModal = (): void => {
    this.setState({ isOpen: true });
  };

  DismissButton = (): JSX.Element => {
    const { dismissable } = this.props;

    if (dismissable) {
      return (
        <button className="close" onClick={this.closeModal}>
          <i className="fas fa-times" />
        </button>
      );
    } else {
      return null;
    }
  };

  render(): JSX.Element {
    const {
      DismissButton,
      props: { children, className, dismissable },
      state: { isOpen },
    } = this;
    return (
      <ReactModal
        ariaHideApp={false}
        className={getClasses("dialog", className)}
        onRequestClose={dismissable ? this.closeModal : null}
        shouldCloseOnOverlayClick={dismissable}
        overlayClassName="overlay"
        {...{ isOpen }}
      >
        <DismissButton />
        {children}
      </ReactModal>
    );
  }
}
